module.exports = __webpack_public_path__ + "static/media/david-edelstein-N4DbvTUDikw-unsplash.4d051b7f.jpg";